/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import styles from './styles';

const ScreenResolutionServices = ({ t, classes }) => {
  const { container, separation, spanBold } = classes;
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowDimensions;
  }
  const { height, width } = useWindowDimensions();

  return (
    <div className={container}>
      <h3 className={separation}>{t('screens.ScreenResolution.title')}</h3>
      <p className={separation}>{t('screens.ScreenResolution.description')}</p>
      <span className={separation}>{t('screens.ScreenResolution.description')}</span>
      <span className={`${separation} ${spanBold}`}>{`${t('screens.ScreenResolution.span1')} ${width} px`}</span>
      <span className={`${separation} ${spanBold}`}>{`${t('screens.ScreenResolution.span2')} ${height} px`}</span>
    </div>
  );
};

ScreenResolutionServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(ScreenResolutionServices));
